import React from 'react';
import { renderToString } from "react-dom/server";
import { mergeProps } from '../../../../generic/Utils/mergeProps';
import ChrInfoPopover from '../../../../generic/Form/Basic/ChrInfoPopover';
import ComparisonTooltip from './ComparisonTooltip';
import { genericConstants } from '../../../../generic/Utils/commonFilterUtils';

const ChrComparison = (props) => {
  const CHANGE_SENTIMENT = genericConstants.TREND_SENTIMENT;
  const CHANGE_DIRECTION = genericConstants.TREND_DIRECTION;
  const NO_CHANGE_VALUE = "—"

  const SENTIMENT_PROPS = {
    [CHANGE_SENTIMENT.POSITIVE]: {
      foregroundColorClass: "cui-management-report-temp-comparison-positive",
      backgroundColorClass: "cui-linear-gradient-lightgreen-transparent",
    },
    [CHANGE_SENTIMENT.NEGATIVE]: {
      foregroundColorClass: "cui-management-report-temp-comparison-negative",
      backgroundColorClass: "cui-linear-gradient-lightred-transparent",
    }
  };

  const CHANGE_ICON = {
    [CHANGE_DIRECTION.INCREASE]: "fa-solid fa-caret-up",
    [CHANGE_DIRECTION.DECREASE]: "fa-solid fa-caret-down"
  };

  let { changeSentiment, changeValue, changeDirection } = props;
  if (changeDirection === CHANGE_DIRECTION.NO_CHANGE)
    changeValue = NO_CHANGE_VALUE;

  let { backgroundColorClass, foregroundColorClass } = { ...SENTIMENT_PROPS[changeSentiment], ...props };

  const containerProps = mergeProps(props.containerProps, {
    className: `d-flex align-items-center flex-gap-5 border-radius-0-25 ${backgroundColorClass} ${foregroundColorClass} cui-management-report-temp-comparison custom-padding-left-0-2 custom-padding-right-0-2 cui-management-report-temp-base-line-height`,
  });
  const { iconProps, valueProps } = props;
  const icon = props.icon || CHANGE_ICON[changeDirection];

  return (
    <ChrInfoPopover
      html
      delay={500}
      boundary="body"
      renderedAsString={ props.renderedAsString }
      content={ renderToString(<ComparisonTooltip periodOne={ props.periodOne } periodTwo={ props.periodTwo } />) }
      placement="auto"
      container="#cjs-management-report-v2"
      trigger="click hover"
      useTemplate
      templateOptions={{ wrapperOptions: { className: "cui-max-width-300-important" }}}
    >
      <div { ...containerProps }>
        { icon &&
          <div { ...iconProps }>
            <i className={ props.icon || CHANGE_ICON[changeDirection] } />
          </div>
        }
        <div { ...valueProps }>
          { changeValue }
        </div>
      </div>
    </ChrInfoPopover>
  );

};

export default ChrComparison;